export default "__VITE_ASSET__Bj2BkjUC__"